<script context="module" lang="ts">
    // declare let Keycloak: any;
</script>

<script lang="ts">
    // import * as Sentry from "@sentry/browser";
    // import { Integrations } from "@sentry/tracing";
    import "bulma-calendar/dist/css/bulma-calendar.css";
    import "bulma/css/bulma.css";
    import { Loader } from "google-maps";
    import LibLoader from "./GlobalComponents/LibLoader.svelte";
    import User from "./GlobalComponents/User.svelte";
    import { ApiClient } from "./GlobalHelper/ApiClient";
    import EventBus from "./GlobalHelper/VertxBridge";
    import Router from "./Router.svelte";
    import Keycloak from "keycloak-js";
    import { user } from "./store";
    import type { IUserStore } from "./Types/User";
    import "carbon-components-svelte/css/g10.css";
    import { onMount } from "svelte";

    let keycloak = new Keycloak("/keycloak.json");
    keycloak
        .init({
            onLoad: "login-required",
        })
        .then(async (auth) => {
            console.log(auth);
            if (auth) {
                const profile = await keycloak.loadUserProfile();
                let newUser: IUserStore = {
                    authenticated: auth,
                    profile: profile,
                    token: keycloak.token,
                    login: keycloak.login,
                    logout: keycloak.logout,
                    updateToken: () => {
                        return keycloak.updateToken(600).then((res) => {
                            user.update((updateTokenUserObject) => {
                                ApiClient.getInstance({
                                    ...updateTokenUserObject,
                                    token: keycloak.token,
                                });
                                return {
                                    ...updateTokenUserObject,
                                    token: keycloak.token,
                                };
                            });
                        });
                    },
                    extendedProfile: null,
                    extendedUserData: null,
                    permissions: [],
                };
                const permissions = await ApiClient.getInstance(
                    newUser
                ).userAuthorityClient.resolvePermissionsForCurrentUser({});
                // console.log(permissions);
                const userOrganisations = await ApiClient.getInstance(newUser)
                    .organisationClient.listOrganisations({})
                    .catch(console.error);
                // console.log(userOrganisations);
                const extendedUserData = await ApiClient.getInstance(newUser)
                    .userClient.getUserAuthorizationContextOrganisation({
                        authorization: newUser.token,
                    })
                    .then((userAuthentication) => userAuthentication);
                // console.log(extendedUserData);
                user.update((userObject) => {
                    return {
                        ...userObject,
                        ...newUser,
                        extendedUserData: extendedUserData,
                        permissions: permissions,
                    };
                });
            } else {
                user.update((user) => {
                    return {
                        ...user,
                        login: keycloak.login,
                        logout: keycloak.logout,
                    };
                });
            }
        });
    /**
     * Initializes User
     */
    async function onLoaded() {
        // Sentry.init({
        //     dsn: "https://2cacd6714ba64e50971ff7c013426732@sentry.whizad.io/3",
        //     integrations: [new Integrations.BrowserTracing()],
        //     tracesSampleRate: 1.0,
        // });

        const googleMapLoader = new Loader(
            "AIzaSyBe_JVp5Yl_SupTbjM2INntwkMZIj5-oCw",
            {}
        );
        await googleMapLoader.load();
    }
    // console.log($user);
</script>

<!-- <div class={$mediaQuery.mql.matches && "has-navbar-fixed-top"}> -->
<div class="main-layout">
    <LibLoader
        urls={[{ url: "/html5-qrcode.min.js", loadedEvent: true }]}
        on:loaded={onLoaded}
    />
    {#if $user?.token && $user?.extendedUserData !== null}
        <Router />
    {/if}

    <!-- {#if !$mediaQuery.mql.matches}
        <div class="user-profile"><User onClickCallback={() => null} /></div>
        <div />
    {/if} -->
</div>

<style>
    .user-profile {
        position: fixed;
        right: 10px;
        top: 10px;
        z-index: 30;
    }

    /* div {
        max-width: 240px;
        margin: 0 auto;
    } */

    @media (min-width: 640px) {
        div {
            max-width: none;
        }
    }
    .has-navbar-fixed-top {
        padding-top: 3.25rem;
    }

    .main-layout {
        display: grid;
        grid-template-columns: 25rem 1fr;
        grid-gap: 2rem;
        padding: 2rem;
        background-color: #f4f4f4;
    }
</style>
